import { AccessTime as AccessTimeIcon } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { styles } from "../../../style";

export default function ActivityCard({ label, icon, subject, detail, rightElement, date, timezone, service }) {
    const DateUI = () => {
        return (
            <>
                {date && (
                    <>
                        <AccessTimeIcon
                            fontSize="small"
                            sx={{
                                // color: config.primaryColor,
                                color: "#F97316",
                                ml: { xs: "1rem", sm: "0px" },
                                width: "15px",
                                // mt: "-1px",
                                mr: "6px",
                            }}></AccessTimeIcon>
                        <Typography
                            component={"span"}
                            variant="paraText5"
                            color={"#000"}
                            borderRight={{ sm: "2px solid #000" }}
                            paddingRight={"0.4rem"}
                            marginRight={"0.4rem"}
                            sx={{ whiteSpace: "nowrap" }}>
                            {date} {timezone}
                        </Typography>
                    </>
                )}
            </>
        );
    };
    const SubjectUI = () => {
        return (
            <>
                <Typography
                    title={subject}
                    component={"h5"}
                    sx={{
                        ...styles.cardHeading,
                        fontWeight: 800,
                        fontSize: "18px",

                        ...(service && {
                            borderRight: { xs: "3px solid #000" },
                            paddingRight: { xs: "0.4rem" },
                            marginRight: { xs: "0.4rem" },
                        }),
                    }}
                >
                    {subject}
                </Typography>
                {service && (
                    <Typography component={"h5"} sx={{ ...styles.cardHeading, fontWeight: 800, fontSize: "18px" }}>
                        {service}
                    </Typography>
                )}
            </>
        );
    };
    const LabelUI = () => {
        return (
            <>
                {(icon || label) && (
                    <Box
                        sx={{
                            borderRadius: "6px",
                            background: "#E9EEFC",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "8px 10px",
                        }}
                    >
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginRight: "4px" }}>{icon}</Box>
                        <Typography component={"span"} fontSize={"15px"} fontWeight={"fontWeightMedium"} sx={{ textAlign: "center", whiteSpace: "nowrap" }}>
                            {label}
                        </Typography>
                    </Box>
                )}
            </>
        );
    };

    return (
        <Box sx={{ marginTop: "1rem", background: "#FAFAF9", border: "1px solid #E9E9E9", borderRadius: "10px" }}>
            <Grid container>
                <Grid
                    sx={{
                        p: { xs: "16px", sm: "20px" },
                    }}
                    xs={12}
                    md={rightElement ? 9 : 12}
                >
                    <Box display={{ xs: "none", sm: "flex" }} justifyContent={"space-between"} alignItems="center">
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <DateUI />
                            <SubjectUI />
                        </Box>

                        <LabelUI />
                    </Box>
                    <Box display={{ xs: "flex", sm: "none" }} justifyContent={"space-between"} alignItems="start" flexDirection="column">
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <LabelUI />
                            <DateUI />
                        </Box>
                        <Box marginTop={"0.5rem"}>
                            <SubjectUI />
                        </Box>
                    </Box>
                    <Box sx={{ mt: "16px" }}>{detail}</Box>
                </Grid>
                {rightElement && (
                    <Grid
                        sx={{ p: { xs: "16px", sm: "20px" }, borderLeft: { md: "1px solid #E9E9E9" }, borderTop: { xs: "1px solid #E9E9E9", md: "unset" } }}
                        xs={12}
                        md={3}
                    >
                        {rightElement}
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}
